<template>
    <v-app id="app">
        <toolbar :token="token"/>
        <v-content>

            <v-dialog
                    v-model="dialog"
                    width="500"
                    persistent
            >
                <v-card>
                    <v-card-title
                            class="headline red lighten-2 white--text"
                            primary-title
                    >
                        <v-icon color="white">mdi-alert</v-icon>&nbsp;&nbsp;คำเตือน
                    </v-card-title>

                    <v-card-text>
                        Version app บนเครื่องของท่าน ({{ current_version }}) ไม่ตรงกับ Server ({{ server_version }})
                        <br>
                        <br>
                        กรุณาโหลดหน้าใหม่ หรือกด Ctrl+F5
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="reloadPage()"
                        >
                            Reload
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <router-view></router-view>
        </v-content>
        <v-footer class="pl-2">v {{ versionControl.version }}</v-footer>
    </v-app>
</template>

<script>
    import Toolbar from "@/components/Toolbar";
    import EventBus from '@/EventBus'
    import axios_auth from '@/axios_auth'
    import axios from '@/axios'



    export default {
        watch: {
            token() {
                if (this.token) {
                    axios.defaults.headers.common['Authorization'] = this.token
                } else {
                    delete axios.defaults.headers.common['Authorization']
                }
            }
        },
        async created(){

            console.log("create")

            this.setAuthHeader()

            EventBus.$on('setToken', params => {
                console.log("setToken")
                this.token = params.token
            })

            EventBus.$on('resetToken', params => {
                console.log("resetToken")
                this.token = ''
            })

            await this.checkVersion()

        },
        mounted() {
            if(this.$router.currentRoute.name=='eval'){
                return true
            }else {

                // begin expire
                let localitem = this.getLocalItem()

                if (!localitem) {
                    return this.$router.replace({name: 'login'})
                }
                if (localitem.availableUntil) {
                    if (this.$moment().diff(this.$moment(localitem.availableUntil, 'MM/DD/YYYY H:i:s'), 'second') > 0) {
                        //return this.$router.replace({name: 'login'})
                        return this.logout()
                    }
                }
                this.token = localitem.token
                // end expire
            }


        },
        data() {
            return {
                token: '',
                dialog:false,
                current_version:0,
                server_version:0,
            }
        },
        computed:{
            versionControl(){
                return JSON.parse(unescape(process.env.PACKAGE_JSON || '%7B%7D'))
            }
        },
        methods:{
            async checkVersion(){
                try {
                    const uri = '/getVersion'
                    const res = await axios.get(uri)
                    if (res){
                        this.current_version = this.versionControl.version
                        this.server_version = res.data.result.version
                        if(this.current_version!=this.server_version){
                            this.dialog = true
                        }
                    }
                } catch (err) {
                    console.log(err.message)
                }
            },
            reloadPage(){
                location.reload()
            }
        },
        components: {
            toolbar: Toolbar
        }
    }
</script>

<style>
    /* Override scroll style  */
    /* width */
    ::-webkit-scrollbar {
        width: 7px;
        height: 6px;
        background-color: transparent;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background-color: #f5f5f5;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgb(224 224 224);
        background: #eee;
        border-radius: 50px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /* Set Base style */
    /** {*/
    /*    font-family: 'Kanit', sans-serif;*/
    /*}*/

    .v-messages__message {
        line-height: 1.5 !important;
    }
</style>
